export const styles = {
  link: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease, color 0.2s ease',
    width: '100%'
  },
  
  container: {
    borderRadius: '4px',
    padding: '16px',
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
    cursor: 'pointer',
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    transition: 'box-shadow 0.2s ease'
  },
  
  containerHover: {
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)'
  },
  
  valueContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '26px',
    lineHeight: '32px',
    fontWeight: '800',
    fontFamily: 'MaryAnn, Trebuchet MS, Arial, Helvetica, sans-serif',
    color: '#404040',
    textAlign: 'center',
    borderRadius: '4px',
    padding: '12px',
    transition: 'color 0.2s ease',
    minHeight: '140px'
  },
  
  valueContainerHover: {
    color: '#f06c00'
  },
  
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
    borderRadius: '4px',
    padding: '8px',
    transition: 'color 0.2s ease'
  },
  
  title: {
    margin: '0',
    fontSize: '22px',
    lineHeight: '26px',
    fontWeight: '800',
    fontFamily: 'MaryAnn, Trebuchet MS, Arial, Helvetica, sans-serif',
    color: '#404040',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    transition: 'color 0.2s ease'
  },
  
  titleHover: {
    color: '#f06c00'
  },
  
  reference: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
    fontFamily: 'Arial, Helvetica Neue, Helvetica, sans-serif',
    color: '#000000',
    transition: 'color 0.2s ease'
  },
  
  referenceHover: {
    color: '#f06c00'
  },
  
  status: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#404040',
    textAlign: 'right',
    lineHeight: '1.4',
    borderRadius: '4px',
    padding: '8px',
    transition: 'color 0.2s ease'
  },
  
  statusHover: {
    color: '#f06c00'
  },
  
  sensorDetail: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
    fontFamily: 'Arial, Helvetica Neue, Helvetica, sans-serif',
    color: '#404040',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    borderRadius: '4px',
    padding: '8px',
    transition: 'color 0.2s ease'
  },
  
  sensorDetailHover: {
    color: '#f06c00'
  },
  
  timestamp: {
    fontSize: '16px',
    fontWeight: '400',
    color: '#404040',
    textAlign: 'right',
    lineHeight: '1.4',
    borderRadius: '4px',
    padding: '8px',
    transition: 'color 0.2s ease'
  },
  
  timestampHover: {
    color: '#f06c00'

  }
};
